import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import { IconButton } from "@mui/joy";
import CssBaseline from "@mui/joy/CssBaseline";
import { CssVarsProvider, extendTheme, useColorScheme } from "@mui/joy/styles";
import * as React from "react";
import {
  RouterProvider,
  createBrowserRouter,
  useNavigate,
  useRouteError,
} from "react-router";
import Activity from "./pages/activity";
import Allcoins from "./pages/allcoins";
import AuthIndex, { siteName } from "./pages/Authentication";
import Login from "./pages/Authentication/login";
import ResetPassword from "./pages/Authentication/resetpassword";
import SignUp from "./pages/Authentication/signup";
import Buy from "./pages/buy";
import CoinDetail from "./pages/coindetail";
import Confirm from "./pages/confirm";
import ConnectWallet from "./pages/connectwallet";
import { DashboardIndex } from "./pages/dashboard";
import HomeIndex from "./pages/homeindex";
import Notification from "./pages/notification";
import Profile from "./pages/profile";
import ReceiveSingle from "./pages/receivesingle";
import Receive from "./pages/recieve";
import Send from "./pages/send";
import Settings from "./pages/settings";
import Success from "./pages/success";
import Swap from "./pages/swap";
import SwapSuccess from "./pages/success";
import InstallPwa from "./pages/installios";
import TransactinDetails from "./pages/transactindetail";
import { UploadId } from "./pages/upload";
import Security from "./pages/security";
import ConnectOptions from "./pages/connectwallet/connectoptions";

const url = `${window.location.protocol}//${window.location.host}`;
export const encodedurl = btoa(url);
export const encodesite = btoa(siteName);

export function ColorSchemeToggle(props) {
  const { onClick, ...other } = props;
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  return (
    <IconButton
      aria-label="toggle light/dark mode"
      size="md"
      sx={{ borderRadius: 50 }}
      variant="outlined"
      disabled={!mounted}
      onClick={(event) => {
        setMode(mode === "light" ? "dark" : "light");
        onClick?.(event);
      }}
      {...other}
    >
      {mode === "light" ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
    </IconButton>
  );
}

const customTheme = extendTheme({
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          50: "#f0fdf4",
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#22c55e",
          600: "#16a34a",
          700: "#15803d",
          800: "#166534",
          900: "#14532d",
        },
        background: {
          body: "#151b23",
          surface: "#151b23",
        },
      },
    },
    light: {
      palette: {
        primary: {
          50: "#f0fdf4",
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#22c55e",
          600: "#16a34a",
          700: "#15803d",
          800: "#166534",
          900: "#14532d",
        },
      },
    },
  },
  defaultColorScheme: "dark",
});

function ErrorBoundary() {
  const navigate = useNavigate();
  let error = useRouteError();
  console.error(error);

  React.useEffect(() => {
    navigate("../");
  });

  // Uncaught ReferenceError: path is not defined
  return <></>;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <DashboardIndex />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/",
        element: <HomeIndex />,
      },
      {
        path: "/swap",
        element: <Swap />,
      },
      {
        path: "/swap/success",
        element: <SwapSuccess />,
      },
      {
        path: "/activity",
        element: <Activity />,
      },
      {
        path: "/allcoin",
        element: <Allcoins />,
      },
      {
        path: "/notifications",
        element: <Notification />,
      },
      {
        path: "/coin",
        element: <CoinDetail />,
      },
      {
        path: "/receive",
        element: <Receive />,
      },
      {
        path: "/receive/coin",
        element: <ReceiveSingle />,
      },
      {
        path: "/buy",
        element: <Buy />,
      },
      {
        path: "/send",
        element: <Send />,
      },
      {
        path: "/passcode",
        element: <Security />,
      },
      {
        path: "/confirm",
        element: <Confirm />,
      },

      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/connectwallet",
        element: <ConnectOptions />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/upload/kyc/:encodedimageurl/:userid",
        element: <UploadId />,
      },

      {
        path: "/detail",
        element: <TransactinDetails />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/success",
        element: <Success />,
        errorElement: <ErrorBoundary />,
      },
    ],
  },
  {
    path: "/connect",
    element: <ConnectWallet />,
  },
  {
    path: "/auth",
    element: <AuthIndex />,
    children: [
      { path: "/auth/login", element: <Login /> },
      { path: "/auth/reset", element: <ResetPassword /> },
      { path: "/auth/register", element: <SignUp /> },
    ],
  },
]);

function App() {
  return (
    <CssVarsProvider
      defaultMode="dark"
      theme={customTheme}
      disableTransitionOnChange
    >
      <CssBaseline />
      <div>
        <InstallPwa />
        <RouterProvider router={router} />
      </div>
    </CssVarsProvider>
  );
}

export default App;
